import * as React from 'react';
import { app } from "@microsoft/teams-js";
import { Avatar, Box, Button, Card, Divider, Flex, FlexItem, Image, Loader, Text, Segment, Tooltip, Video } from "@fluentui/react-northstar";
import { initializeIcons, Icon } from '@fluentui/react';
import { AcceptIcon, ArrowDownIcon, PaperclipIcon, ChatIcon, StarIcon, CustomerHubIcon } from '@fluentui/react-icons-northstar';
import { getMeetingData, getQueueById, getCurrentUserPhoto, getQueueRecordingFile, getUserPermissions } from '../../../api/teamsapp-api';
import { getAppSettings } from '../../../api/settings-api';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import StatusQueueConstants from "../../../constants/status-queue";
import Features from "../../../constants/features";
import Roles from '../../../constants/roles';
import Channels from '../../../constants/channels';
import './post-meeting-panel.scss';
const moment = require('moment');


interface IPostMeetingPanel extends WithTranslation {
    queueId: string;
    meetingQueueData: any;
    atendentePhoto: string;
}

interface IPostMeetingState {
    history: any;
    meetingQueueData: any | null;
    atendentePhoto: string | null;
    loading: boolean | null;
    authEnabled: boolean | null;
    govBrEnabled: boolean | null;
    recordingEnabled: boolean | null;
    videos: any[];
    selectedVideo: string;
    videoPart: number;
    features: string[];
    userQueueAttachmentsSettingsEnabled: boolean;
    userQueueAttachmentsUnitSettingsEnabled: boolean;
    loadingSettings: boolean;
    loadingUnitSettings: boolean;
    hasAttachments: boolean;
    attachments: any[];
    loadingRole: boolean;
    role: string | null;
    chatId: string | null;
}

class PostMeetingPanel extends React.Component<IPostMeetingPanel, IPostMeetingState> {
    private localize: TFunction;
    private params: any;
    private searchParam?: any = null;
    private isTeamContext?: boolean = false;
    private userId?: any = null;

    constructor(props: IPostMeetingPanel) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            history: [],
            meetingQueueData: null,
            atendentePhoto: null,
            loading: true,
            loadingRole: true,
            authEnabled: false,
            govBrEnabled: false,
            recordingEnabled: false,
            videos: [],
            selectedVideo: "",
            videoPart: 0,
            features: [],
            userQueueAttachmentsSettingsEnabled: false,
            userQueueAttachmentsUnitSettingsEnabled: false,
            loadingSettings: true,
            loadingUnitSettings: true,
            hasAttachments: false,
            attachments: [],
            role: null,
            chatId: null,
        }

        this.searchParam = new URLSearchParams(window.location.search);
        this.isTeamContext = this.searchParam.get("isTeamContext");
    }

    public async componentDidMount() {
        app.initialize();

        app.getContext().then(async (context: app.Context) => {
            this.userId = context.user.id;
            this.params = this.props;
            let params = this.params.match?.params;

            if (params) {
                if ('id' in params) {
                    let id = params['id'];
                    let ancora = params['ancora'];

                    await this.getAppSettings();
                    await this.getUserRole();
                    await this.getMeeting(ancora);
                    await this.getMeetingQueueData(id);
                }
            } else {
                await this.getUserRole();
                await this.getMeeting(this.props.meetingQueueData.Ancora);
                await this.getMeetingQueueData(this.props.meetingQueueData.id);

                this.setState({
                    loading: false,
                    history: this.props.meetingQueueData?.History,
                })
            }
        });
    }

    private getUserRole = async () => {
        const response = await getUserPermissions();

        if (response.status === 200 && response.data) {
            this.setState({
                role: response.data,
                loadingRole: false,
            })
        }
    }

    private getAppSettings = async () => {
        const response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                userQueueAttachmentsSettingsEnabled: response.data.userQueueAttachments,
                recordingEnabled: response.data.autoRecordingGovernance,
                features: response.data.featuresList,
                loadingSettings: false,
            })
        }
    }

    public getMeeting = async (ancora: string) => {
        const response = await getMeetingData(ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                authEnabled: response.data.authEnabled,
                govBrEnabled: response.data.govBrEnabled,
                userQueueAttachmentsUnitSettingsEnabled: response.data.userQueueAttachments
            })
        }
    }

    public getMeetingQueueData = async (queueId: string) => {
        const response = await getQueueById(queueId);

        if (response.status === 200 && response.data) {
            const responsePhoto = await getCurrentUserPhoto(response.data.atendenteId);

            this.setState({
                meetingQueueData: response.data,
                atendentePhoto: responsePhoto.data,
                history: response.data.History,
                loading: response.data.RecordedFiles ? true : false,
                chatId: response.data.OnlineMeetingData?.chatInfo?.threadId,
                hasAttachments: response.data.hasAttachments,
                attachments: response.data.hasAttachments ? response.data.Attachments : null,
            }, async () => {
                if (response.data.RecordedFiles) {
                    const files = response.data.RecordedFiles.files.map((file: any) => {
                        return this.getQueueRecordingFile(file.id, response.data.id);
                    });

                    await Promise.all(files).then(this.fetchRecordingFiles);
                }
            })
        }
    }

    public getQueueRecordingFile = async (fileId: string, queueId: string) => {
        return await getQueueRecordingFile(fileId, queueId);
    }

    public fetchRecordingFiles = (response: any) => {
        if (response.length) {
            this.setState({
                videos: response,
                selectedVideo: response[0].data,
                loading: false,
            })
        }
    }

    public formatRatingLabel = (rate: number) => {
        let labelSuffix = "";

        switch (rate) {
            case 5:
                labelSuffix = rate.toString() + " - Ótimo";
                break;
            case 4:
                labelSuffix = rate.toString() + " - Bom";
                break;
            case 3:
                labelSuffix = rate.toString() + " - Regular";
                break;
            case 2:
                labelSuffix = rate.toString() + " - Insuficiente";
                break;
            case 1:
                labelSuffix = rate.toString() + " - Fraco";
                break;
        }

        return labelSuffix
    }

    public renderBoxes = (queueData: any) => {
        return (
            <Flex gap="gap.medium" column>
                <Flex className="boxes" gap="gap.medium" space="between">
                    <FlexItem size="size.half">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Flex gap="gap.small" space="between" style={{ minHeight: "2rem", marginBottom: "1.5rem" }}>
                                    <Flex gap="gap.medium" column>
                                        <Text content="Detalhes da solicitação" style={{ margin: 0 }} weight="bold" />
                                    </Flex>
                                </Flex>

                                <Flex>
                                    {queueData.AdditionalData ?
                                        <ul>
                                            {queueData.AdditionalData?.description &&
                                                <li><strong>Descrição:</strong> <Text content={queueData.AdditionalData?.description} /></li>
                                            }

                                            {queueData.AdditionalData?.department &&
                                                <li><strong>Lotação:</strong> <Text content={queueData.AdditionalData?.department} /></li>
                                            }

                                            {queueData.AdditionalData?.location &&
                                                <li><strong>Lotação / Promotoria / Caixa / Unidade:</strong> <Text content={queueData.AdditionalData?.location} /></li>
                                            }

                                            {queueData.AdditionalData?.nrProcesso &&
                                                <li><strong>Número do processo:</strong> <Text content={queueData.AdditionalData?.nrProcesso} /></li>
                                            }

                                            {queueData.AdditionalData?.tipoAudiencia &&
                                                <li><strong>Tipo da audiência:</strong> <Text content={queueData.AdditionalData?.tipoAudiencia} /></li>
                                            }

                                            {queueData.AdditionalData?.sigilo &&
                                                <li><strong>Sigiloso:</strong> <Text content={queueData.AdditionalData?.sigilo === "true" ? "Sim" : "Não"} /></li>
                                            }

                                            {(queueData.assunto && queueData.Schedule) &&
                                                <li><strong>Observações:</strong> <Text content={queueData.assunto} /></li>
                                            }
                                        </ul>
                                        :
                                        <Text content="Nenhum detalhe disponível." />
                                    }
                                </Flex>

                                {queueData.notes &&
                                    <>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem", marginBottom: "1.5rem" }}>
                                            <Flex gap="gap.medium" column>
                                                <Text content="Notas do atendente" style={{ margin: 0 }} weight="bold" />
                                            </Flex>
                                        </Flex>
                                        <Flex>
                                            <Text size="small" content={queueData.notes} />
                                        </Flex>
                                    </>
                                }
                            </Flex>
                        </Segment>
                    </FlexItem>

                    <FlexItem size="size.half">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Flex gap="gap.small" space="between" style={{ minHeight: "2rem", marginBottom: "1.5rem" }}>
                                    <Flex gap="gap.small" column>
                                        <Text content={this.localize("InformacoesReuniao")} style={{ margin: 0 }} weight="bold" />
                                    </Flex>
                                </Flex>
                                <Flex className="chat-button" gap="gap.medium" column>
                                    {this.state.chatId ?
                                        <Button
                                            content={this.localize("EntrarChat")}
                                            icon={<ChatIcon outline />}
                                            onClick={() => {
                                                const url = window.location.ancestorOrigins[0].includes("cloud") ?
                                                    `https://teams.cloud.microsoft/l/chat/${this.state.chatId}` : `https://teams.microsoft.com/l/chat/${this.state.chatId}`;

                                                app.openLink(url);
                                            }}

                                            fluid
                                        />
                                        :
                                        <Text content="Nenhuma informação disponível." />
                                    }
                                        
                                </Flex>

                                {((this.state.role == Roles.gestor && this.isTeamContext != null) || this.isTeamContext == null) &&
                                    <>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem", marginBottom: "1.5rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Text content={this.localize("Avaliacao")} style={{ margin: 0 }} weight="bold" />
                                            </Flex>
                                        </Flex>

                                        {queueData?.Rating ?
                                            <Flex gap="gap.medium" column>
                                                {queueData?.Rating?.Rate &&
                                                    <Flex gap="gap.small">
                                                        <Flex className="ratingBox">
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 1} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 2} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 3} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 4} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 5} />
                                                        </Flex>

                                                        {this.isTeamContext != null ?
                                                            <Text content={
                                                                queueData.Rating.Rate == 1 ? this.localize("Ruim") :
                                                                    queueData.Rating.Rate == 2 ? this.localize("Regular") :
                                                                        queueData.Rating.Rate == 3 ? this.localize("Bom") :
                                                                            queueData.Rating.Rate == 4 ? this.localize("Ótimo") : this.localize("Excelente")
                                                            } />  
                                                        :
                                                            <Text content={this.formatRatingLabel(queueData.Rating.Rate)} /> 
                                                        }
                                                        
                                                    </Flex>
                                                }

                                                {queueData?.Rating?.Comments &&
                                                    <Flex gap="gap.small" column>
                                                        <Text weight="semibold" size="medium" content={this.localize("Comentarios")} />
                                                        <Text weight="light" size="small" content={queueData?.Rating.Comments} />
                                                    </Flex>
                                                }
                                            </Flex>
                                            :
                                            <Flex>
                                                <Text content={this.localize("UsuarioNaoAvaliou")} />
                                            </Flex>
                                        }
                                    </>
                                }
                            </Flex>
                        </Segment>
                    </FlexItem>
                </Flex>


                {this.state.hasAttachments &&
                    <Flex className="attachments">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("Anexos")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    <Flex gap="gap.medium" column>
                                        {this.renderAttachments()}
                                    </Flex>
                                </Card.Body>
                            </Flex>
                        </Segment>
                    </Flex>
                }

                {(queueData.RecordedFiles &&
                    this.state.features?.includes(Features.RecordingGovernance) &&
                    this.state.recordingEnabled &&
                    this.state.videos.length &&
                    (this.state.meetingQueueData.atendenteId == this.userId || this.state.role == Roles.gestor)) &&
                    <Flex className="recording">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("Gravacao")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.medium" column>
                                            {this.renderRecordings()}
                                        </Flex>
                                    </Flex>
                                </Card.Body>
                            </Flex>
                        </Segment>
                    </Flex>
                }
            </Flex>
        );
    }

    public renderRecordings = () => {
        return (
            <Flex gap="gap.medium" column fill>
                {this.state.videos &&
                    <React.Fragment>
                        <Video
                            src={this.state.selectedVideo + `#t=0.59`}
                            variables={{ width: '100%' }}
                            controls
                            controlsList="nofullscreen"
                        />

                        <Flex gap="gap.medium" wrap>
                            <Button
                                icon={<ArrowDownIcon />}
                                content={this.localize("DownloadGravacao")}
                                onClick={() => window.open(this.state.selectedVideo)}
                            />

                            {this.state.videos.length > 1 &&
                                this.state.videos.map((file: any, index: number) => {
                                    return (
                                        <Button
                                            key={index}
                                            className="video-parts"
                                            content={`${this.localize("Parte")} ${index + 1}`}
                                            primary={this.state.videoPart == index}
                                            onClick={
                                                () => {
                                                    this.setState({
                                                        selectedVideo: file.data,
                                                        videoPart: index,
                                                    })
                                                }
                                            }
                                        />
                                    )
                                })
                            }
                        </Flex>
                    </React.Fragment>
                }
            </Flex>
        );
    }

    public renderFiles = (attachment: any) => {
        const fileUrl = attachment.fileUrl;
        const fileUrlBase64 = window.btoa(fileUrl).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

        return (
            <Flex gap="gap.medium">
                <PaperclipIcon />
                <Text
                    as="a"
                    href={`${window.location.origin}/file/${fileUrlBase64}`}
                    size="medium"
                    className="file-link"
                    content={attachment.name.split('_').pop()}
                    target="_blank"
                />
            </Flex>
        );
    }

    public renderAttachments = () => {
        return (
            <Flex gap="gap.medium" column fill>
                {this.state.hasAttachments &&
                    <React.Fragment>
                        <Flex gap="gap.medium" vAlign="center" column>
                            {this.state.attachments.map((attachment: any) => {
                                return this.renderFiles(attachment)
                            })}
                        </Flex>
                    </React.Fragment>
                }
            </Flex>
        )
    }

    public chunkItems = (items: any[], size: number): any[][] => {
        const chunks: any[][] = [];
        for (let i = 0; i < items.length; i += size) {
            chunks.push(items.slice(i, i + size));
        }
        return chunks;
    };

    public render() {
        const statusNaFila = this.state.history?.find((e: any) => e.status == StatusQueueConstants.naFila)?.created ?? null;
        const statusIniciado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoIniciado)?.created ?? null;
        const statusAgendado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created ?? null;
        const meetingQueueData = this.state.meetingQueueData ?? this.props.meetingQueueData;

        let prefix = "#";
        let queueId = `${prefix}${meetingQueueData?.id.substr(meetingQueueData?.id.length - 6)}`;

        if (meetingQueueData && meetingQueueData.channel == Channels.bot) {
            prefix = !meetingQueueData.AdditionalData?.prefix ? prefix : meetingQueueData.AdditionalData.prefix;
        }

        if (meetingQueueData && meetingQueueData.AdditionalData?.nrProcesso) {
            prefix = "";
            queueId = meetingQueueData.AdditionalData?.nrProcesso;
        }

        const { history } = this.state;
        const chunks = this.chunkItems(history, 8);

        return (
            <div className="main-component-extensibility">
                {(this.state.loading || this.state.loadingRole) ?
                    <Loader />
                    :
                    <Flex className="post-meeting-panel" column>
                        <Segment className="container-panel">
                            <Flex vAlign="center">
                                <Flex.Item>
                                    <Flex className="unit-name" column padding="padding.medium" vAlign="center" gap="gap.medium">
                                        <Flex vAlign="center" gap="gap.medium">
                                            <Flex gap="gap.small" column>
                                                {!meetingQueueData.Schedule ?
                                                    <Text size="large" content={`${this.localize("Atendimento")} ${queueId}`} />
                                                    :
                                                    <Text size="large" content={
                                                        <Flex column>
                                                            <Text size="large" content={this.localize("Agendamento")} />
                                                            <Text size="large" content={`${prefix}${queueId}`} />
                                                        </Flex>
                                                    } />
                                                }
                                                
                                                <Flex gap="gap.small" vAlign="center" column>
                                                    <Text size="small" content={meetingQueueData?.nome} />
                                                    {meetingQueueData?.assunto && !meetingQueueData?.Schedule &&
                                                        <div className="tag">{meetingQueueData?.assunto}</div>
                                                    }
                                                </Flex> 
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                </Flex.Item>

                                <Flex.Item grow>
                                    <Flex gap="gap.medium" padding="padding.medium" hAlign="end" styles={{ height: "6rem", paddingRight: "2rem" }}>
                                        {(this.state.authEnabled && this.state.govBrEnabled) || meetingQueueData.UserProfile &&
                                            <React.Fragment>
                                                <Flex gap="gap.medium">
                                                    <Flex gap="gap.smaller" column>
                                                        {meetingQueueData?.UserProfile?.userPhoto ?
                                                            <Avatar
                                                                image={`data:image/jpeg;base64,${meetingQueueData?.UserProfile?.userPhoto}`}
                                                                size="large"
                                                            />
                                                            :
                                                            <Avatar
                                                                name={meetingQueueData?.UserProfile?.userName}
                                                                size="large"
                                                            />
                                                        }
                                                    </Flex>

                                                    <Flex gap="gap.smaller" column>
                                                        <Flex gap="gap.small">
                                                            <Text weight="semibold" content={this.localize("Solicitante")} />
                                                            {(this.state.authEnabled && this.state.govBrEnabled) &&
                                                                <Image width="45" src="https://studio365cdn.azureedge.net/balcaovirtual/gov-br.svg" />
                                                            }
                                                        </Flex>

                                                        <Text size="small" content={meetingQueueData?.UserProfile?.userName} />
                                                    </Flex>
                                                </Flex>

                                                {meetingQueueData.status != StatusQueueConstants.naFila &&
                                                    <Divider vertical />
                                                }
                                            </React.Fragment>
                                        }


                                        {meetingQueueData.status != StatusQueueConstants.naFila &&
                                            <Flex gap="gap.smaller" column>
                                                {!statusAgendado ?
                                                    <Text weight="semibold" content={this.localize("IniciadoEm")} />
                                                    :
                                                    <Text weight="semibold" content={this.localize("AgendadoEm")} />
                                                }
                                                
                                                {!statusAgendado ?
                                                    <>
                                                        {statusIniciado ?
                                                            <Text size="small" content={moment(statusIniciado).format("DD/MM HH:mm")} />
                                                            :
                                                            <Text content="-" />
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        <Text size="small" content={moment(statusAgendado).format("DD/MM HH:mm")} />
                                                    </>
                                                }
                                            </Flex>
                                        }

                                        {(meetingQueueData.status == StatusQueueConstants.atendimentoEncerrado && !statusAgendado) &&
                                            <>
                                                <Divider vertical />
                                                <Flex gap="gap.smaller" column>
                                                    <Text weight="semibold" content={this.localize("EncerradoEm")} />
                                                    <Text size="small" content={moment(meetingQueueData.updated).format("DD/MM HH:mm")}
                                                    />
                                                </Flex>
                                            </>
                                        }

                                        {(statusAgendado && meetingQueueData.Schedule) &&
                                            <>
                                                <Divider vertical />
                                                <Flex gap="gap.smaller" column>
                                                    <Text weight="semibold" content={this.localize("DataAgendamentoLabel")} />
                                                    <Text size="small" content={moment(meetingQueueData.Schedule.date).format("DD/MM HH:mm")}
                                                    />
                                                </Flex>
                                            </>
                                        }

                                        {this.state.meetingQueueData.atendenteId != null &&
                                            <React.Fragment>
                                                <Divider vertical />

                                                <Flex gap="gap.medium">
                                                    <Flex gap="gap.smaller" column>
                                                        {this.state.atendentePhoto != "" &&
                                                            <Avatar
                                                                image={`data:image/jpeg;base64,${this.state.atendentePhoto}`}
                                                                size="large"
                                                            />
                                                        }
                                                        {this.state.atendentePhoto == "" &&
                                                            <Flex gap="gap.smaller">
                                                                <Avatar size="large" name={meetingQueueData?.atendenteName} />
                                                            </Flex>
                                                        }
                                                    </Flex>

                                                    <Flex gap="gap.smaller" column>
                                                        {!meetingQueueData.Schedule ? 
                                                            <Text weight="semibold" content={this.localize("Atendente")} />
                                                            : 
                                                            <Text weight="semibold" content={this.localize("AgendadoPor")} />
                                                        }
                                                        
                                                        <Text size="small" content={meetingQueueData?.atendenteName} />
                                                    </Flex>
                                                </Flex>
                                            </React.Fragment>
                                        }


                                    </Flex>
                                </Flex.Item>
                            </Flex>
                        </Segment>

                        <div>
                            {chunks.map((chunk, chunkIndex) => (
                                <Flex className="statusHistory" key={chunkIndex}>
                                    {chunk.map((item, index) => (
                                        <Flex.Item grow>
                                            <Flex
                                                className="status"
                                                vAlign="center"
                                                hAlign="center"
                                                gap="gap.smaller"
                                                column
                                            >
                                                {item.status === 'atendimentoEncerrado' && item.notes && (
                                                    <Tooltip
                                                        content={
                                                            <Flex gap="gap.small" column>
                                                                <Text weight="semibold" content="Observações do encerramento" />
                                                                <Text weight="light" content={item.notes} />
                                                            </Flex>
                                                        }
                                                        trigger={
                                                            <Flex className="message-notes">
                                                                <CustomerHubIcon outline className="message-icon" />
                                                            </Flex>
                                                        }
                                                    />
                                                )}

                                                {item.status === StatusQueueConstants.atendimentoAgendado ?
                                                    <Text className="status-info" weight="semibold" content={this.localize("Agendado")} />
                                                    : item.status === StatusQueueConstants.atendimentoIniciado ?
                                                    <Text className="status-info" weight="semibold" content={this.localize("Iniciado")} />
                                                    : item.status === StatusQueueConstants.atendimentoEncerrado ?
                                                    <Text className="status-info" weight="semibold" content={this.localize("Encerrado")} />
                                                    :
                                                    <Text className="status-info" weight="semibold" content={item.status} />
                                                }
                                                
                                                <Box className="status-icon">
                                                    <AcceptIcon size="small" />
                                                </Box>
                                                <Flex className="status-time" gap="gap.smaller" vAlign="center">
                                                    <Icon className="margin-style clock-icon" iconName="Clock" />
                                                    <Text size="small" content={moment(item.created).format("HH:mm")} />
                                                </Flex>
                                            </Flex>
                                        </Flex.Item>
                                    ))}
                                </Flex>
                            ))}
                        </div>

                        {this.renderBoxes(meetingQueueData)}
                    </Flex>
                }
            </div>
        );
    }
}

const postMeetingPanelWithTranslation = withTranslation()(PostMeetingPanel);
export default postMeetingPanelWithTranslation;